import { Calendar } from "lucide-react";
import { InteriorHead, ActionLink } from "@/components/luminous/interior";
import { routesFor, type Lang } from "@/components/luminous/primitives";

interface CaseStudiesHubHeroProps {
  language: Lang;
}

const content = {
  es: {
    eyebrow: "Casos de éxito",
    title: "Casos de éxito reales en SEO, Amazon Ads y branding",
    definition:
      "Cada caso muestra el contexto real del cliente, el problema concreto y el trabajo realizado: sin promesas genéricas ni cifras sin origen.",
    audienceLabel: "Para quién es esto:",
    audience:
      "Empresas B2B, marcas de consumo y fabricantes que quieren ver el proceso completo antes de decidir.",
    cta: "Solicitar reunión inicial gratuita",
    facts: [
      { label: "Industrias", value: "Amazon / marketplace, alimentos y bebidas, farmacéutica, abrasivos industriales" },
      { label: "Alcance", value: "SEO técnico, Amazon Ads, branding, e‑commerce y desarrollo a medida" },
      { label: "Evidencia", value: "Capturas reales del proyecto, con periodo y fuente indicados en cada pie de imagen" },
    ],
  },
  en: {
    eyebrow: "Case studies",
    title: "Real case studies in SEO, Amazon Ads and branding",
    definition:
      "Each case shows the client's real context, the concrete problem and the work performed: no generic promises, no figures without a source.",
    audienceLabel: "Who this is for:",
    audience:
      "B2B companies, consumer brands and manufacturers who want to see the full process before deciding.",
    cta: "Request free initial consultation",
    facts: [
      { label: "Industries", value: "Amazon / marketplace, food and beverage, pharmaceutical, industrial abrasives" },
      { label: "Scope", value: "Technical SEO, Amazon Ads, branding, e-commerce and custom development" },
      { label: "Evidence", value: "Real screenshots of the project, with period and source noted in each caption" },
    ],
  },
} as const;

export const CaseStudiesHubHero = ({ language }: CaseStudiesHubHeroProps) => {
  const t = content[language];
  const routes = routesFor(language);

  return (
    <InteriorHead
      crumbs={[
        { label: language === "es" ? "Inicio" : "Home", to: routes.home },
        { label: t.eyebrow },
      ]}
      eyebrow={t.eyebrow}
      title={t.title}
      definition={t.definition}
      audienceLabel={t.audienceLabel}
      audience={t.audience}
      facts={t.facts}
      actions={
        <ActionLink to={routes.seoDiagnosis}>
          <Calendar className="h-4 w-4" aria-hidden />
          {t.cta}
        </ActionLink>
      }
    />
  );
};
